export default "__VITE_ASSET__Dvp85$6A__"